<div class="edit-rmu-root">
  <div class="edit-rmu-header">
    <div class="rmu-header-info">
      <div class="rmu-info">
        <div class="row">
          <div class="slrn col-7">
            {{ rmu.slrn ? rmu.slrn : ("COMMON.NO_SLRN" | translate) }}
          </div>
          <div></div>
          <div
            class="col-2 rmu-status complete-rmu"
            *ngIf="
              disableUpdateStatusButton() &&
              rmu.valdiationStatus != null &&
              rmu.valdiationStatus!.toString() == 'Approved'
            "
          >
            {{ "COMMON.ASSET_STATUS.COMPLETE" | translate }}
          </div>
          <div
            class="col-2 rmu-status rejected-rmu"
            *ngIf="
              disableUpdateStatusButton() &&
              rmu.valdiationStatus != null &&
              rmu.valdiationStatus!.toString() == 'Rejected'
            "
          >
            {{ "COMMON.ASSET_STATUS.REJECTED" | translate }}
          </div>
          <div
            class="col-2 rmu-status"
            *ngIf="!disableUpdateStatusButton() && rmu.assetStatus"
            [ngClass]="{
              'pending-rmu': rmu.assetStatus.toString() == 'Pending',
              'assigned-rmu':
                rmu.assetStatus.toString() == 'Assigned' ||
                rmu.assetStatus.toString() == 'Retagged'
            }"
          >
            {{
              "COMMON.ASSET_STATUS." + rmu.assetStatus | uppercase | translate
            }}
          </div>
          <!-- <div
            class="col-2 rmu-status pending-rmu"
            *ngIf="
              (!disableUpdateStatusButton() && !rmu.assetStatus) ||
              rmu.valdiationStatus == null
            "
          >
            --------
          </div> -->
        </div>
      </div>
      <div class="rmu-address">
        <!-- <div class="name">{{'TRANSFORMERS.EDIT.SLRN' | translate}}</div> -->
        <div
          *ngIf="rmu.dtStatus"
          class="rmu-status"
          [ngClass]="{
            'active-rmu': rmu.dtStatus.toString() == 'Active',
            'inactive-rmu': rmu.dtStatus.toString() == 'Inactive',
            'suspended-rmu': rmu.dtStatus.toString() == 'Suspended',
            'decomissioned-rmu': rmu.dtStatus.toString() == 'Decommissioned'
          }"
        >
          {{
            "TRANSFORMERS.DT_STATUS_OPTIONS." + rmu.dtStatus
              | uppercase
              | translate
          }}
        </div>
      </div>
    </div>

    <div class="action-buttons">
      <button
        class="btn btn-header"
        data-bs-toggle="modal"
        (click)="getMobileUsers(); setModalType(AssetAssignType.Retagged)"
        data-bs-target="#assignToFieldAgent"
      >
        {{ "COMMON.RETAG" | translate }}
      </button>
      <div class="recall-div">
        <button
          class="btn btn-header recall-button"
          style="color: black"
          (click)="showRecallMenu = !showRecallMenu"
        >
          <span class="recall-span">{{ "COMMON.RECALL" | translate }}</span>
        </button>
        <div *ngIf="showRecallMenu" class="recall-options">
          <div
            class="recall-type"
            [ngClass]="[
              !recallAssignedAllowed
                ? 'recall-type-disabled'
                : 'recall-type-enabled'
            ]"
            (click)="recallAssignedAllowed ? recall() : null"
          >
            <span>{{ "COMMON.ASSIGNED_TASK" | translate }}</span>
          </div>
          <div
            class="recall-type"
            [ngClass]="[
              !recallValidatedAllowed
                ? 'recall-type-disabled'
                : 'recall-type-enabled'
            ]"
            (click)="recallValidatedAllowed ? recall() : null"
          >
            <span>{{ "COMMON.VALIDATED_TASK" | translate }}</span>
          </div>
        </div>
      </div>

        <!-- remove || true when we get rejection questions approve and reject should work when those are added to the db -->
      <button
        class="btn btn-header"
        data-bs-toggle="modal"
        data-bs-target="#updateStatus"
        [disabled]="disableUpdateStatusButton()"
      > 
        {{ "COMMON.UPDATE_STATUS" | translate }}
      </button>
      <button
        class="btn btn-header"
        data-bs-toggle="modal"
        data-bs-target="#auditReview"
        [disabled]="disableAuditReviewButton()"
      >
        {{ "COMMON.FIELD_AUDIT" | translate }}
      </button>
      <button
        class="btn btn-header"
        data-bs-toggle="modal"
        (click)="getMobileUsers(); setModalType(AssetAssignType.Assigned)"
        data-bs-target="#assignToFieldAgent"
      >
        {{ "COMMON.ASSIGN_AGENT" | translate }}
      </button>
       <button class="btn btn-header" *ngIf="!editEnabled && permissionsService.isRmusCreateEditAllowed"
          (click)="edit()">
          {{'COMMON.EDIT' | translate}}
        </button>
        <button class="btn btn-primary" *ngIf="editEnabled" (click)="validateInput($event)">
          {{'COMMON.SAVE' | translate}}
        </button>
       <button class="btn btn-primary" #openUpdateDescriptionModal data-bs-toggle="modal" data-bs-target="#history"
          hidden></button>
    </div>
  </div>

  <div class="edit-rmu-body">
    <div class="main-col">
      <div class="card container">
  <div class="row">
    <div class="col-5">
      <p class="card-title">{{ "RMU.EDIT.INFORMATION" | translate }}</p>
    </div>
    <div class="col-7">
      <div class="line-2"></div>
    </div>
  </div>

  <!-- Voltage Level -->
  <div class="row">
    <div class="col-5">{{ "RMU.EDIT.VOLTAGE_LEVEL" | translate }}</div>
    <div class="col-7">
      <ng-container *ngIf="!editEnabled; else voltageLevelEdit">
        {{ rmu.voltageLevel.toString() == "KV11" ? "11kV" : ("33kV" | hasValue)}}
      </ng-container>
      <ng-template #voltageLevelEdit>
        <select
          [(ngModel)]="tempVoltageLevel"
          (change)="updateVoltageLevel()"
          class="form-select">
          <option *ngFor="let option of voltageLevelOptions" [value]="option">{{ option == "KV11" ? "11kV" : ("33kV" | hasValue) }}</option>
        </select>
      </ng-template>
    </div>
  </div>


  <!-- RMU EDIT -->
  <div class="row">
  <div class="col-5">{{ "RMU.EDIT.STATUS" | translate }}</div>
  <div class="col-7">
    <ng-container *ngIf="!editEnabled; else statusEdit">
      {{ 'RMU.EDIT.STATUS_DROPDOWN.'+ rmu.dtStatus.toString().toUpperCase()| hasValue | translate }}
    </ng-container>
    <ng-template #statusEdit>
      <select [(ngModel)]="rmu.dtStatus" class="form-select">
        <option *ngFor="let option of statusOptions" [value]="option">
          {{ 'RMU.EDIT.STATUS_DROPDOWN.' + option.toUpperCase() | translate }}
        </option>
      </select>
    </ng-template>
  </div>
</div>

  <!-- Fenced Status -->
  <div class="row">
    <div class="col-5">{{ "RMU.EDIT.RMU_FENCED_STATUS" | translate }}</div>
    <div class="col-7">
      <ng-container *ngIf="!editEnabled; else fencedStatusEdit">
        {{ rmu.fencedStatus | hasValue | translate }}
      </ng-container>
      <ng-template #fencedStatusEdit>
        <select [(ngModel)]="rmu.fencedStatus" class="form-select">
          <option *ngFor="let option of fencedStatusOptions" [value]="option">
            {{ 'RMU.EDIT.FENCING_DROPDOWN.' + option.toUpperCase().replace(' ', '_') | translate }}
          </option>
        </select>
      </ng-template>
    </div>
  </div>

  <!-- Manufacturer Name -->
  <div class="row">
    <div class="col-5">{{ "RMU.EDIT.MANUFACTURER" | translate }}</div>
    <div class="col-7">
      <ng-container *ngIf="!editEnabled; else manufacturerEdit">
        {{ rmu.manufacturerName | hasValue }}
      </ng-container>
      <ng-template #manufacturerEdit>
        <input type="text" [(ngModel)]="rmu.manufacturerName" class="form-control" />
      </ng-template>
    </div>
  </div>

  <!-- Serial Number -->
  <div class="row">
    <div class="col-5">{{ "RMU.EDIT.SERIAL_NUMBER" | translate }}</div>
    <div class="col-7">
      <ng-container *ngIf="!editEnabled; else serialNumberEdit">
        {{ rmu.serialNumber | hasValue }}
      </ng-container>
      <ng-template #serialNumberEdit>
        <input type="text" [(ngModel)]="rmu.serialNumber" class="form-control" />
      </ng-template>
    </div>
  </div>

  <!-- Number of Outputs -->
  <div class="row">
    <div class="col-5">{{ "RMU.EDIT.NUMBER_OF_OUTPUTS" | translate }}</div>
    <div class="col-7">
      <ng-container *ngIf="!editEnabled; else numberOfOutputsEdit">
        {{ rmu.numberOfOutput | hasValue }}
      </ng-container>
      <ng-template #numberOfOutputsEdit>
        <input type="number" [(ngModel)]="rmu.numberOfOutput" class="form-control" min="0" />
      </ng-template>
    </div>
  </div>

  <!-- RMU Type -->
  <div class="row">
    <div class="col-5">{{ "RMU.EDIT.RMU_TYPE" | translate }}</div>
    <div class="col-7">
      <ng-container *ngIf="!editEnabled; else rmuTypeEdit">
        {{ rmu.type | hasValue | translate }}
      </ng-container>
      <ng-template #rmuTypeEdit>
        <select [(ngModel)]="rmu.type" class="form-select">
          <option *ngFor="let option of rmuTypeOptions" [value]="option">
            {{ 'RMU.EDIT.TYPE_DROPDOWN.' + option.toUpperCase().replace('-', '_') | translate }}
          </option>
        </select>
      </ng-template>
    </div>
  </div>

 <!-- Manufacture Date -->
<div class="row">
  <div class="col-5">{{ "RMU.EDIT.MANUFACTURE_DATE" | translate }}</div>
  <div *ngIf="!editEnabled" class="col-7">
      {{ rmu.manufactureDate| date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}
    </div>
    <div *ngIf="editEnabled" class="col-7">
      <input type="date" id="dateManufacturer" name="dateManufacturer" class="btn datepicker-icon"
        [(ngModel)]="dateManufacturerString" (change)="setDateOfManufacturer()" />
    </div>
</div>

<!-- Commissioning Date -->
<div class="row">
  <div class="col-5">{{ "RMU.EDIT.COMMISION_DATE" | translate }}</div>
  <div *ngIf="!editEnabled" class="col-7">
      {{ rmu.commissioningDate| date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}
    </div>
    <div *ngIf="editEnabled" class="col-7">
      <input type="date" id="dateComission" name="dateManufacturer" class="btn datepicker-icon"
        [(ngModel)]="dateComissionString" (change)="setDateOfComission()" />
    </div>
</div>

  <!-- Location Address -->
  <div class="row">
    <div class="col-5">{{ "RMU.EDIT.LOCATION_ADDRESS" | translate }}</div>
    <div class="col-7">
      <ng-container *ngIf="!editEnabled; else locationAddressEdit">
        {{ rmu.locationAddress | hasValue }}
      </ng-container>
      <ng-template #locationAddressEdit>
        <input type="text" [(ngModel)]="rmu.locationAddress" class="form-control" />
      </ng-template>
    </div>
  </div>

  <!-- Location Landmark -->
  <div class="row">
    <div class="col-5">{{ "RMU.EDIT.LOCATION_LANDMARK" | translate }}</div>
    <div class="col-7">
      <ng-container *ngIf="!editEnabled; else locationLandmarkEdit">
        {{ rmu.locationLandmark | hasValue }}
      </ng-container>
      <ng-template #locationLandmarkEdit>
        <input type="text" [(ngModel)]="rmu.locationLandmark" class="form-control" />
      </ng-template>
    </div>
  </div>

  <!-- Existing Geo Location section remains unchanged -->
  <div class="row" *ngIf="rmu.longitude != null && rmu.longitude != null">
    <div class="locationText col-5">
      {{ "COMMON.MBC_DETAILS.GEO_LOCATION" | translate }}
    </div>
    <div class="locationText col-6 d-flex justify-content-end">
      {{ rmu.latitude }} , {{ rmu.longitude }}
    </div>
    <div class="location col-1" (click)="isMapVisible = !isMapVisible">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 500"
        data-bs-toggle="modal"
        data-bs-target="#showMap"
      >
        <path
          d="M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128zm128 80c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
          fill="#026962"
        />
      </svg>
    </div>
  </div>
  <div class="row" *ngIf="rmu.longitude == null || rmu.longitude == null">
    <div class="locationText col-5">
      {{ "COMMON.MBC_DETAILS.GEO_LOCATION" | translate }}
    </div>
    <div class="locationText col-7 d-flex justify-content-end">
      {{ null | hasValue }}
    </div>
  </div>
</div>

      <div class="card container">
        <div class="row">
          <div class="col-5">
            <p class="card-title">
              {{ "RMU.EDIT.CONNECTED" | translate }}
            </p>
          </div>
          <div class="col-7">
            <div class="line-2"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-5">{{ "RMU.EDIT.CONNECTED_DTS" | translate }}</div>
          <div class="col-7">{{ rmu.connectedDts | hasValue }}</div>
        </div>
        <div class="row">
          <div class="col-5">{{ "RMU.EDIT.CONNECTED_BDS" | translate }}</div>
          <div class="col-7">{{ rmu.connectedBuildings | hasValue }}</div>
        </div>
        <div class="row">
          <div class="col-5">{{ "RMU.EDIT.CONNECTED_CUST" | translate }}</div>
          <div class="col-7">{{ rmu.customerPopulation | hasValue }}</div>
        </div>
      </div>
    </div>

    <div class="main-col">
      <div class="card container">
        <div class="row">
          <div class="col-5">
            <p class="card-title">
              {{ "RMU.EDIT.NETWORK_INFORMATION" | translate }}
            </p>
          </div>
          <div class="col-7">
            <div class="line-2"></div>
          </div>
        </div>

        <div class="row" *ngIf="rmu.transmissionStation">
          <div class="col-5">{{ "RMU.EDIT.TS" | translate }}</div>
          <div class="col-7">{{ rmu.transmissionStation | hasValue }}</div>
        </div>
        <div class="row" *ngIf="rmu.feeder33Name">
          <div class="col-5">{{ "RMU.EDIT.KV33_FEEDER" | translate }}</div>
          <div class="col-7">{{ rmu.feeder33Name | hasValue }}</div>
        </div>
        <div class="row" *ngIf="rmu.substationName">
          <div class="col-5">{{ "RMU.EDIT.SS" | translate }}</div>
          <div class="col-7">{{ rmu.substationName | hasValue }}</div>
        </div>
        <div class="row" *ngIf="rmu.feeder11Name">
          <div class="col-5">{{ "RMU.EDIT.KV11_FEEDER" | translate }}</div>
          <div class="col-7">{{ rmu.feeder11Name | hasValue }}</div>
        </div>
        <div class="row">
          <div class="col-5">{{ "RMU.EDIT.REGION" | translate }}</div>
          <div class="col-7">{{ rmu.region | hasValue }}</div>
        </div>
        <div class="row">
          <div class="col-5">{{ "RMU.EDIT.DISTRICT" | translate }}</div>
          <div class="col-7">{{ rmu.district | hasValue }}</div>
        </div>
      </div>

      <div class="card container">
        <div class="row">
          <div class="col-5">
            <p class="card-title">{{ "RMU.EDIT.USER_ACTIVITY" | translate }}</p>
          </div>
          <div class="col-7">
            <div class="line-2"></div>
          </div>
        </div>

        <div class="row">
          <div class="col-5">
            {{ "COMMON.USER.TYPE.FIRST_CAPTURED" | translate }}
          </div>
          <div class="col-7">{{ rmu.firstCapturedUser | hasValue }}</div>
        </div>
        <div class="row">
          <div class="col-5">
            {{ "COMMON.USER.TYPE.LAST_CAPTURED" | translate }}
          </div>
          <div class="col-7">{{ rmu.lastCapturedUser | hasValue }}</div>
        </div>
        <div class="row">
          <div class="col-5">{{ "RMU.EDIT.CREATION_DATE" | translate }}</div>
          <div class="col-7">{{ rmu.creationDate | hasValue }}</div>
        </div>
        <div class="row">
          <div class="col-5">{{ "RMU.EDIT.UPDATED_DATE" | translate }}</div>
          <div class="col-7">{{ rmu.updatedDate | hasValue }}</div>
        </div>
        <div class="row">
          <div class="col-5">
            {{ "COMMON.USER.TYPE.REASSIGNED" | translate }}
          </div>
          <div class="col-7">{{ rmu.reassignedBy | hasValue }}</div>
        </div>
        <div class="row">
          <div class="col-5">{{ "RMU.EDIT.ASSIGNED_USER" | translate }}</div>
          <div class="col-7">{{ rmu.assignedUser | hasValue }}</div>
        </div>
        <div class="row">
          <div class="col-5">
            {{ "COMMON.USER.TYPE.VALIDATED" | translate }}
          </div>
          <div class="col-7">{{ rmu.validatedBy | hasValue }}</div>
        </div>
        <div class="row">
          <div class="col-5">{{ "RMU.EDIT.VALIDATED_DATE" | translate }}</div>
          <div class="col-7">{{ rmu.validatedDate | hasValue }}</div>
        </div>
        <div class="row">
          <div class="col-5">{{ "RMU.EDIT.AUDITED_STATUS" | translate }}</div>
          <div class="col-7">{{ rmu.auditedStatus | hasValue }}</div>
        </div>
        <div class="row">
          <div class="col-5">{{ "COMMON.USER.TYPE.AUDITED" | translate }}</div>
          <div class="col-7">{{ rmu.auditedBy | hasValue }}</div>
        </div>
        <div class="row">
          <div class="col-5">{{ "RMU.EDIT.AUDITED_STATUS" | translate }}</div>
          <div class="col-7">{{ rmu.auditedDate | hasValue }}</div>
        </div>
        <div class="row">
          <div class="col-5">
            {{ "RMU.EDIT.VALIDATION_STATUS" | translate }}
          </div>
          <div class="col-7">{{ rmu.valdiationStatus | hasValue }}</div>
        </div>
        <div class="row">
          <div class="col-5">{{ "RMU.EDIT.COMMENT" | translate }}</div>
          <div class="col-7">{{ rmu.comment | hasValue }}</div>
        </div>
      </div>
    </div>
    <div class="image-container main-col">
      <div class="card container">
        <div>{{ "COMMON.PICTURES.TAG_MOUNTED" | translate }}</div>

        <div class="images-list single-image-list">
          <app-image-section
            [image]="getMountedTagImage()"
            [index]="0"
            [imageType]="ImageType.MountedTag"
            [editEnabled]="editEnabled"
            [inputId]="'fileMounted' + 0"
            (imageClick)="showImage(ImageType.MountedTag)"
            (fileChange)="fileBrowserHandler($event)"
          >
          </app-image-section>
        </div>
      </div>

        <div class="card container">
        <div>{{ "COMMON.PICTURES.RMU" | translate }}</div>

        <div class="images-list single-image-list">
          <app-image-section
            [image]="getRMUImage()"
            [index]="0"
            [imageType]="ImageType.RMU"
            [editEnabled]="editEnabled"
            [inputId]="'fileRMU' + 0"
            (imageClick)="showImage(ImageType.RMU)"
            (fileChange)="fileBrowserHandler($event)"
          >
          </app-image-section>
        </div>
      </div>
        <div class="card container">
        <div>{{ "COMMON.PICTURES.RMU_NAMEPLATE" | translate }}</div>

        <div class="images-list single-image-list">
          <app-image-section
            [image]="getNameplatePictureImage()"
            [index]="0"
            [imageType]="ImageType.NameplatePicture"
            [editEnabled]="editEnabled"
            [inputId]="'fileNAMEPLATE' + 0"
            (imageClick)="showImage(ImageType.NameplatePicture)"
            (fileChange)="fileBrowserHandler($event)"
          >
          </app-image-section>
        </div>
      </div>
        <div class="card container">
        <div>{{ "COMMON.PICTURES.CABLE_ENTRY" | translate }}</div>

        <div class="images-list single-image-list">
          <app-image-section
            [image]="getCableEntryPointsImage()"
            [index]="0"
            [imageType]="ImageType.CableEntryPoints"
            [inputId]="'fileCABLEENTRY' + 0"
            (imageClick)="showImage(ImageType.CableEntryPoints)"
            (fileChange)="fileBrowserHandler($event)"
          >
          </app-image-section>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="auditReview" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ "COMMON.FIELD_AUDIT" | translate }}</h5>
        <button
          type="button"
          #closeAudit
          class="btn-cancel-modal"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          {{ "COMMON.CANCEL" | translate }}
        </button>
      </div>
      <app-audit-review
        (closeModal)="cancelAudit()"
        assetType="RMU"
        [assetId]="id"
        [areaId]="rmu.areaId"
      ></app-audit-review>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="assignToFieldAgent"
  tabindex="-1"
  aria-hidden="true"
  (hidden.bs.modal)="onModalAssignFade()"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5
          *ngIf="assetAssignType == AssetAssignType.Assigned"
          class="modal-title"
        >
          {{ "COMMON.ASSIGN_AGENT" | translate }}
        </h5>
        <h5
          *ngIf="assetAssignType == AssetAssignType.Retagged"
          class="modal-title"
        >
          {{ "COMMON.RETAG_TASK" | translate }}
        </h5>
        <button
          type="button"
          #closeModal
          class="btn-cancel-modal"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          {{ "COMMON.CANCEL" | translate }}
        </button>
      </div>
      <div class="modal-body">
        <div class="form-floating form-item">
          <input
            #userFilterInput
            autocomplete="off"
            type="text"
            name="filterText"
            [(ngModel)]="filterText"
            class="form-control filter-field"
            [ngClass]="{ 'valid-input': tempAssignedUserId != 0 }"
            id="floatingInput"
            (ngModelChange)="filterMobileUsers()"
            (click)="openDropdown()"
            placeholder=" "
          />
          <label for="floatingInput">{{
            "COMMON.FIELD_AGENT" | translate
          }}</label>

          <div
            class="filtered-agent-list"
            *ngIf="isDropdownOpened"
            #dropdownContainer
          >
            <div
              click-stop-propagation
              class="agent-name"
              (click)="selectFieldAgent(u.id)"
              *ngFor="let u of mobileUsers"
            >
              {{ u.fullName }}
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="assignTask()">
          <span *ngIf="assetAssignType == AssetAssignType.Assigned">{{
            "COMMON.ASSIGN_TASK" | translate
          }}</span>
          <span *ngIf="assetAssignType == AssetAssignType.Retagged">{{
            "COMMON.RETAG_TASK" | translate
          }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal modalMap" id="showImageMap" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-building-map [setMapVisibility]="isImageMapVisible" [longitude]="selectedImage?.longitude"
          [latitude]="selectedImage?.latitude"></app-building-map>
      </div>
    </div>
  </div>
</div>

<div class="modal modalMap" id="showMap" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          #closeAddModal
          class="close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-building-map
          [setMapVisibility]="isMapVisible"
          [longitude]="rmu.longitude"
          [latitude]="rmu.latitude"
        ></app-building-map>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="modalImage" tabindex="-1" aria-hidden="true" (hidden.bs.modal)="onModalFade()"
  (shown.bs.modal)="onModalOpen()">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content modal-image">
      <div class="modal-body modal-body-image">
        <div class="image-container" [style.transform]="'rotate(' + currentRotation + 'deg)'">
          <lib-ngx-image-zoom [zoomMode]="'hover-freeze'" [fullImage]="selectedImage?.url"
            [thumbImage]="selectedImage?.url" [magnification]="3">
          </lib-ngx-image-zoom>
        </div>
        <div class="rotate-div">
          <button class="btn btn-primary left-button" (click)="rotateLeft()">&lt;</button>
          <button class="btn btn-primary right-button" (click)="rotateRight()">&gt;</button>
        </div>
        <app-image-geo-info [image]="selectedImage"
          (mapClicked)="isImageMapVisible = !isImageMapVisible"></app-image-geo-info>
      </div>
    </div>
  </div>
</div>
<div class="modal" id="updateStatus" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'COMMON.DATA_VALID_REVIEW' | translate}}</h5>
        <button type="button" #closeModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
          {{'COMMON.CANCEL' | translate}}
        </button>
      </div>
      <div class="modal-body">
        <app-data-quality assetType="Rmu" [assetId]="id" [areaId]="rmu.areaId"></app-data-quality>
      </div>
    </div>
  </div>
</div>